var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.78711C10.7842 2.78711 17.5 9.50294 17.5 17.7871H15C15 10.8838 9.40333 5.28711 2.5 5.28711V2.78711ZM2.5 8.62044C7.5625 8.62044 11.6667 12.7246 11.6667 17.7871H9.16667C9.16667 16.019 8.46429 14.3233 7.21405 13.0731C5.9638 11.8228 4.26811 11.1204 2.5 11.1204V8.62044ZM2.5 14.4538C3.38405 14.4538 4.2319 14.805 4.85702 15.4301C5.48214 16.0552 5.83333 16.9031 5.83333 17.7871H2.5V14.4538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.586e732b61b23b6dbc2c0e057fba4b1e.svg";
export { ForwardRef as ReactComponent };